import createReducer from '../utils/createReducer';
import actions from '../actions/currency';
import {getComponentState} from '../utils/localStorageDataHandler';

const initialState = {};

const actionHandlers = {
    [actions.GET_CURRENCIES_SUCCESS](state, {payload}) {
        const {currency, userInfo} = payload.currencyMetadata;

        if (currency instanceof Array && currency.length === 1) {
            return {
                ...state,
                currencyList: currency,
                enableContinueButton: true,
                userInfo
            };
        }

        return {
            ...state,
            currencyList: currency,
            userInfo
        };
    },

    [actions.CURRENCY_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            errorKey: payload.errorKey
        };
    },

    [actions.GET_SUPPORTED_CURRENCIES_SUCCESS](state, {payload}) {
        const {supportedCurrencies} = payload;

        return {
            ...state,
            supportedCurrencies
        };
    },

    [actions.SET_CURRENCY](state, {payload}) {
        return {
            ...state,
            currency: payload.currency
        };
    },

    [actions.SET_CURRENCY_CHANGE_ERROR](state, {payload}) {
        return {
            ...state,
            currencyChangeError: payload.errorKey
        };
    },

    [actions.ENABLE_CONTINUE_BUTTON](state, {payload}) {
        return {
            ...state,
            enableContinueButton: payload.enable
        };
    },

    [actions.PRE_POPULATE_LOCAL_STATE_CURRENCY](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'currency');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state
        };
    }
};

export default createReducer(actionHandlers, initialState);
